import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  id: "report_list"
};
const _hoisted_2 = {
  class: "nav"
};
const _hoisted_3 = {
  class: "search-area"
};
const _hoisted_4 = {
  class: "reportsbox"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  key: 2
};
const _hoisted_9 = {
  key: 1,
  class: "report-item"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[5] || (_cache[5] = _createElementVNode("div", {
    style: {
      "flex": "1"
    }
  }, "我的报告", -1)), _createElementVNode("div", _hoisted_3, [_cache[3] || (_cache[3] = _createElementVNode("p", {
    style: {
      "width": "85px"
    }
  }, "有效时间起：", -1)), _createVNode(_component_el_date_picker, {
    modelValue: $setup.datePicker[0],
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.datePicker[0] = $event),
    type: "date",
    placeholder: "选择有效时间止"
  }, null, 8, ["modelValue"]), _cache[4] || (_cache[4] = _createElementVNode("p", {
    style: {
      "width": "85px",
      "margin-left": "10px"
    }
  }, "有效时间止：", -1)), _createVNode(_component_el_date_picker, {
    modelValue: $setup.datePicker[1],
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.datePicker[1] = $event),
    type: "date",
    placeholder: "选择有效时间止"
  }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
    class: "s-input",
    type: "primary",
    plain: "",
    onClick: $setup.getReportList
  }, {
    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("搜索", -1)]))]),
    _: 1
  }, 8, ["onClick"])])]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.reports, (item, key, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "item",
      key: index
    }, [item.skill ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "report-item report-item-over",
      onClick: $event => $setup.goReport(item, key)
    }, [key != 'S9' ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($setup.store.state.skill[key]) + "技能诊断报告", 1)) : _createCommentVNode("", true), key != 'S9' ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(item.time), 1)) : (_openBlock(), _createElementBlock("p", _hoisted_8, "你已完成“综合英语能力测试”，谢谢！")), _createElementVNode("div", {
      class: _normalizeClass('report-icon-over ' + key)
    }, null, 2)], 8, _hoisted_5)) : (_openBlock(), _createElementBlock("div", _hoisted_9, [key != 'S9' ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString($setup.store.state.skill[key]) + "暂无技能诊断报告 ", 1)) : (_openBlock(), _createElementBlock("p", _hoisted_11, "“综合英语能力测试”未完成")), _createElementVNode("div", {
      class: _normalizeClass('report-icon ' + key)
    }, null, 2)]))]);
  }), 128)), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, index => {
    return _createElementVNode("div", {
      class: "report-item report-item-block",
      key: 'block' + index
    });
  }), 64))])]);
}